import axios from "axios";
import { toast } from "react-toastify";
import ApiConfig from "../config/ApiConfig";
import { errorMessage } from "../lib/helper";
import {
  setRegisteredAgentDataLoading,
  setRegisteredAgentData,
} from "../redux/signup";
import { STATUS_200, STATUS_300 } from "../data/constants";
import agentAxios from "../lib/AxiosInterceptor";

export const AgentRegistration = async (
  payload,
  extraConfig,
  isAddingFromAgent
) => {
  if (payload !== undefined) {
    try {
      let response;
      if (isAddingFromAgent == true) {
        response = await agentAxios.post(
          `${ApiConfig.agentRegister}`,
          payload,
          extraConfig
        );
      } else {
        response = await axios.post(
          `${ApiConfig.agentNewRegister}`,
          payload,
          extraConfig
        );
      }
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) { 
        if (isAddingFromAgent == true) {
          toast.success(`Agent is Successfully Created`, {
            autoClose: 2500,
            className: "toast-message",
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          localStorage.removeItem("agent_token");
          localStorage.removeItem("agent_user");
          toast.success(
            `Heyy ${
              response?.data?.data?.name || ""
            }! we've sent a OTP to your registered email address.`,
            {
              autoClose: 2500,
              className: "toast-message",
              position: toast.POSITION.TOP_RIGHT,
            }
          );
        }
        return true;
      } else {
        throw response;
      }
    } catch (e) { 
      if(e?.data?.data?.email){
        toast.error(e?.data?.data?.email[0], {
          autoClose: 2500,
        });
      }
     else if(e?.data?.data?.contact_number){
      toast.error(e?.data?.data?.contact_number[0], {
        autoClose: 2500,
      });
     }
     else{
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
    }
      return false;
    }
  }
};

export const VerifyOtpForSignup = async (payload, extraConfig) => {
  if (payload !== undefined) {
    // return async (dispatch) => {
    try {
      // dispatch(setAuthUserDataLoading(true));
      const response = await axios.post(
        `${ApiConfig.agentNewRegister}`,
        payload,
        extraConfig
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        // dispatch(setAuthUserData(response?.data?.data?.userDetail));
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        toast.success(
          `Heyy ${response?.data?.data?.name}! Verified Successfully.`,
          {
            autoClose: 2500,
            className: "toast-message",
            position: toast.POSITION.TOP_RIGHT,
          }
        );
        // dispatch(setAuthUserDataLoading(false));
        return true;
      } else {
        throw response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      // dispatch(setAuthUserDataLoading(false));
      return false;
    }
  }
  // }
};
